import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

//---------------------- DETECT TOUCH ---------------------//

var isTouchDevice = "ontouchstart" in document.documentElement;
if (isTouchDevice) {
  $("body").removeClass("no-touch");
  $("body").addClass("has-touch");
}

//---------------------- READY EVENT ---------------------//

$(document).ready(function () {
  //---------------------- Kurs Slider ---------------------//
  const kurseSwiper = new Swiper(".kurse__swiper", {
    modules: [Navigation, Pagination, A11y],
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 1, // desktop: full single slide, no peek
        spaceBetween: 0,
      },
    },
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: ".kurse__swiper-button-next",
      prevEl: ".kurse__swiper-button-prev",
      addIcons: false,
    },

    pagination: {
      el: ".kurse__swiper-pagination",
      type: "bullets",
    },

    a11y: {
      prevSlideMessage: "Vorherige Folie",
      nextSlideMessage: "Nächste Folie",
      firstSlideMessage: "Dies ist die erste Folie",
      lastSlideMessage: "Dies ist die letzte Folie",
      paginationBulletMessage: "Gehe zu Folie {{index}}",
    },

    // play the active slide's video, pause the rest
    on: {
      afterInit: updateSlideVideos,
      slideChangeTransitionEnd: updateSlideVideos,
    },
  });

  // recalc when each video knows its real dimensions
  $(".kurse__swiper video").on("loadedmetadata", function () {
    kurseSwiper.updateAutoHeight();
  });

  // recalc after everything has loaded
  $(window).on("load", function () {
    kurseSwiper.update();
    kurseSwiper.updateAutoHeight();
  });

  //---------------------- Play active slide video ---------------------//
  var sliderInView = false; // top-level, shared with the observer below

  function updateSlideVideos() {
    // pause (and rewind) every video in this slider, including clones
    document.querySelectorAll(".kurse__swiper video").forEach(function (v) {
      v.pause();
      v.currentTime = 0;
    });

    // only play if the slider is actually in the viewport
    if (!sliderInView) return;

    var activeVideo = document.querySelector(
      ".kurse__swiper .swiper-slide-active video",
    );
    if (activeVideo) {
      activeVideo.play().catch(function () {});
    }
  }

  //---------------------- Play only when slider is visible ---------------------//
  (function () {
    var sliderEl = document.querySelector(".kurse__swiper");
    if (!sliderEl || !("IntersectionObserver" in window)) {
      sliderInView = true; // fallback: no IO support → behave as before
      updateSlideVideos();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sliderInView = entry.isIntersecting;
          updateSlideVideos(); // play when it enters, pause when it leaves
        });
      },
      { threshold: 0.5 }, // "visible" = at least 25% of the slider on screen
    );

    io.observe(sliderEl);
  })();

  //---------------------- Kurs Slider Videos ---------------------//
  (function () {
    var mq = window.matchMedia("(max-width: 767px)");

    function applyAll() {
      // re-query every time so CLONES are included too
      $("video[data-mobile-src]").each(function () {
        var $video = $(this);
        var video = this;

        var src = mq.matches
          ? $video.attr("data-mobile-src")
          : $video.attr("data-desktop-src");

        if ($video.attr("src") !== src) {
          $video.attr("src", src);
          video.load();
        }
      });
    }

    applyAll(); // run once now that Swiper's clones exist

    if (mq.addEventListener) {
      mq.addEventListener("change", applyAll);
    } else {
      mq.addListener(applyAll); // older Safari
    }
  })();

  //---------------------- Honeypot ---------------------//
  if ($("#inpEmail2").length > 0) {
    $("#inpEmail2").hide();
  }

  //---------------------- Main Nav ---------------------//

  if (window.matchMedia("(min-width: 1024px)").matches) {
    $(".has-touch li.has-dropdown > a").click(function (event) {
      event.preventDefault();
    });
  }

  $(".site-header__toggle-nav").click(function () {
    $("body").toggleClass("nav-open");
  });

  $("li.has-dropdown > span").click(function () {
    $(this).parent().toggleClass("nav-open");
    $(this).next().slideToggle();
  });

  $(".lang-switcher").click(function () {
    $(this).parent().toggleClass("open");
  });

  //------------ Automatic/safe target blank -------------//
  //------------ for external links ----------------------//

  // $('a[href^="http"]').attr({
  //   target: "_blank",
  //   rel: "noopener"
  // });
  // $('a[href^="//"]').attr({
  //   target: "_blank",
  //   rel: "noopener"
  // });
  // $('a[href^="' + window.location.origin + '"]').attr("target", "_self");

  //------------------ Smooth Scroll ----------------//

  $('a:not(.no-scroll)[href*="#"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);

    $("html, body").stop().animate(
      {
        scrollTop: $target.offset().top,
      },
      900,
      "swing",
    );
  });

  //------------------ Accordion ----------------//

  var acc = document.getElementsByClassName("accordion__trigger");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("open");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  /// Other accordion toggles
  $(".niveaustufen__item .toggle").each(function (index, element) {
    var accId = $(element).data("accordion");
    $(element).on("click", function (event) {
      $('.accordion__trigger[data-accordion="' + accId + '"]').trigger("click");
    });
  });

  //------------------ Calculator ----------------//

  // Single Selection
  $(".input-select-module").on("change", function (event) {
    var parent = $(this).data("niveau");
    var $sidebarParent = $("#" + parent);
    var $sidebarModule = $("#" + $(this).data("module"));
    var $activeModules = $(
      '.input-select-module[data-niveau="' + parent + '"]:checked',
    );

    if ($(this).prop("checked")) {
      $sidebarParent.removeClass("is-hidden");
      $sidebarModule.removeClass("is-hidden");
    } else {
      $sidebarModule.addClass("is-hidden");
      if ($activeModules.length == 0) {
        $sidebarParent.addClass("is-hidden");
      }
    }

    if ($activeModules.length > 0) {
      $(".konfigurator__sidebar-inactive").addClass("is-hidden");
      $(".konfigurator__sidebar-active").removeClass("is-hidden");
      calculatePrice();
    } else {
      $(".konfigurator__sidebar-inactive").removeClass("is-hidden");
      $(".konfigurator__sidebar-active").addClass("is-hidden");
    }

    populateInput();
  });

  $(".input-select-kursart").on("change", function (event) {
    var price = $(this).data("price");
    var parent = $(this).data("niveau");
    var type = $(this).val();
    var $sidebarParent = $("#" + parent);
    var $checkboxes = $('.input-select-module[data-niveau="' + parent + '"]');

    $checkboxes.data("price", price);
    $sidebarParent.find(".module-price").text(currencyFormatDE(price));
    $sidebarParent.find(".module-type").each(function (index) {
      $(this).text(type);
    });

    calculatePrice();
    populateInput();
  });

  // Select all
  $(".input-select-all").on("change", function (event) {
    var $checkboxes = $(
      '.input-select-module[data-niveau="' + $(this).data("niveau") + '"]',
    );

    if ($(this).prop("checked")) {
      $checkboxes.prop("checked", true).trigger("change");
    } else {
      $checkboxes.prop("checked", false).trigger("change");
      $(".input-select-module:checked").trigger("change");
    }
  });

  // Populate Input Field
  function populateInput() {
    var $selectedModules = $(
      ".konfigurator__sidebar li.module:not(.is-hidden)",
    );

    // var textShort = $selectedModules.map(function() {
    //   return $(this).find('.module-title').html();
    // }).get().join(', ');
    //$('input#selected-modules-full').val(textShort);

    var text = $selectedModules
      .map(function () {
        return (
          $(this).find(".module-title").html() +
          " (" +
          $(this).find(".module-type").html() +
          ")"
        );
      })
      .get()
      .join(", ");

    $("input#modulesList").val(text);
  }

  // Calculate price
  function calculatePrice() {
    var $activeModules = $(".input-select-module:checked");
    var totalPrice = 0;
    //var modulePrice = parseFloat($('input[name="kursart"]').prop("checked", true).data('price'));

    var discount = 0;
    var discountRate = parseFloat($("#calculation").data("discount-rate"));
    var discountLimit = parseFloat($("#calculation").data("discount-limit"));
    var discountedPrice = 0;

    $activeModules.each(function (index, element) {
      totalPrice += parseFloat($(element).data("price"));
    });

    if ($activeModules.length >= discountLimit) {
      discount = (totalPrice / 100) * discountRate;
      discountedPrice = totalPrice - discount;
    }

    $("#discount").text(currencyFormatDE(discount));
    $("#total").text(currencyFormatDE(totalPrice));
  }

  function currencyFormatDE(num) {
    return (
      num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
    ); // use . as a separator
  }

  //------------------ Category Filter ----------------//
  $("#filter-categories").change(function () {
    var filter = $(this).val();
    $(".filter__item").hide();

    if (filter == "Alle" || filter == "All") {
      $(".filter__item").show();
    } else {
      $(".filter__item").each(function () {
        if ($(this).data("category") == filter) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });
});
